// Cleanup stale gifts immediately when script loads
function cleanupStaleGiftsOnLoad() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let staleGifts = [];
      cart.items.forEach((item) => {
        if (item.properties && item.properties["gift"] && !item.properties["Gift"]) {
          staleGifts.push(item.key);
        }
      });
      
      if (staleGifts.length > 0) {
        let updateData = { updates: {} };
        staleGifts.forEach(key => updateData.updates[key] = 0);
        
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updateData),
        }).then(() => {
          // Refresh cart display if needed
          if (typeof updateCartDisplay === 'function') {
            updateCartDisplay();
          }
        });
      }
    })
    .catch((err) => console.error(err));
}

cleanupStaleGiftsOnLoad();

if (!customElements.get("new-gift-picker")) {
  customElements.define(
    "new-gift-picker",
    class NewGiftPicker extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          triggers: document.querySelectorAll("[data-gifting-trigger]"),
          containers: this.querySelectorAll('[id^="GiftPickerContainer"]'),
          pickers: this.querySelectorAll('[id^="GiftPickerItem"]')
        };

        this.collectionHandles = [
          "gifting-amount",
          "gifting-item-price",
          "gifting-item-quantity",
        ];
        this.lineItems = lineItems;
        this.giftingRules = giftingRules.gifting;
        this.selectedGiftItems = [];
        this.selectedGiftItemsQuantity = {};

        this.setupGiftingTriggers();
        this.setupGiftPickerItems();
      }

      setupGiftingTriggers() {
        this.elements.triggers.forEach((trigger) => {
          let handler = null;
          if (trigger.onclick) {
            handler = trigger.onclick;
            trigger.onclick = null;
          }
          if (trigger.dataset.redirectTo) {
            handler = function () {
              window.location.href = trigger.dataset.redirectTo;
            };
          }
          trigger.addEventListener("click", (event) => {
            event.preventDefault();
            trigger.setAttribute("aria-disabled", true);
            trigger.classList.add("loading");
            trigger.disabled = true;
            this.processGifting(event, handler);
          });
        });
      }

      setupGiftPickerItems() {
        this.cleanupStaleGifts();
        this.setSelectedGiftItems();
        this.setSelectedGiftItemsQuantity();
      }

      cleanupStaleGifts() {
        this.getStaleGiftItems().then((staleGifts) => {
          if (staleGifts.length > 0) {
            let updateData = { updates: {} };
            staleGifts.forEach(item => updateData.updates[item.key] = 0);
            this.removeGiftsFromCart(updateData);
          }
        });
      }

      getGiftCartItems() {
        return new Promise((resolve, reject) => {
          fetch("/cart.js")
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              resolve(
                data.items.filter(
                  (item) =>
                    item.properties &&
                    this.collectionHandles.includes(item.properties["Gift"])
                )
              );
            })
            .catch((err) => {
              console.error(err);
            });
        });
      }

      // For removing gifts that were added from the previous campaign
      getStaleGiftItems() {
        return new Promise((resolve, reject) => {
          fetch("/cart.js")
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              resolve(
                data.items.filter(
                  (item) =>
                    item.properties &&
                    item.properties["gift"] &&
                    !item.properties["Gift"]
                )
              );
            })
            .catch((err) => {
              console.error(err);
            });
        });
      }

      getCartTotalPrice() {
        return new Promise((resolve, reject) => {
          fetch("/cart.js")
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              resolve(data.total_price);
            })
            .catch((err) => {
              console.error(err);
            });
        });
      }

      // Added checks for removing gifts that were added from the previous campaign
      removeAllGiftsFromCart() {
        return new Promise((resolve, reject) => {
          Promise.all([this.getGiftCartItems(), this.getStaleGiftItems()]).then(([currentGifts, staleGifts]) => {
            let data = { updates: {} };

            currentGifts.forEach((item) => {
              data.updates[item.key] = 0;
            });

            staleGifts.forEach((item) => {
              data.updates[item.key] = 0;
            });

            if (Object.keys(data.updates).length > 0) {
              this.removeGiftsFromCart(data).then(() => {
                this.removeGiftsFromCart(data).then((result) => {
                  resolve(result);
                });
              });
            } else {
              resolve(true);
            }
          });
        });
      }

      setSelectedGiftItems() {
        this.getCartTotalPrice().then((price) => {
          {
            let result = [];
            this.elements.pickers = this.querySelectorAll(
              '[id^="GiftPickerItem"]'
            );
            this.elements.pickers.forEach((picker) => {
              if (picker.dataset.collection == "gifting-amount") {
                if (
                  picker.checked &&
                  price >= picker.dataset.rangeMin &&
                  price <= picker.dataset.rangeMax
                ) {
                  result.push({
                    variantId: picker.value,
                    collection: picker.dataset.collection,
                  });
                }
              }
              if (picker.dataset.collection == "gifting-item-price") {
                if (picker.checked) {
                  result.push({
                    variantId: picker.value,
                    collection: picker.dataset.collection,
                  });
                }
              }
              if (picker.dataset.collection == "gifting-item-quantity") {
                if (picker.checked) {
                  result.push({
                    variantId: picker.value,
                    collection: picker.dataset.collection,
                    quantity: picker.dataset.quantity,
                  });
                }
              }
            });
            this.selectedGiftItems = result;
          }
        });
      }

      setSelectedGiftItemsQuantity() {
        let result = {};
        this.selectedGiftItems.forEach((item) => {
          result[item.variantId + "_" + item.collection] =
            (result[item.variantId + "_" + item.collection] || 0) + 1;
        });
        this.selectedGiftItemsQuantity = result;
      }

      assembleGiftItemData() {
        let result = {
          items: [],
        };

        let uniqueItems = [...new Set(this.selectedGiftItems)];

        uniqueItems.forEach((item) => {
          result.items.push({
            quantity:
              item.quantity ||
              this.selectedGiftItemsQuantity[
                item.variantId + "_" + item.collection
              ] ||
              1,
            id: item.variantId,
            properties: {
              Gift: item.collection,
            },
          });
        });

        return result;
      }

      removeGiftsFromCart(data) {
        return new Promise((resolve, reject) => {
          fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              console.log(response.ok);
              resolve(response.ok);
            })
            .catch((err) => {
              console.error(err);
              reject(false);
            });
        });
      }

      addGiftsToCart(data) {
        return new Promise((resolve, reject) => {
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              console.log(response.ok);
              resolve(response.ok);
            })
            .catch((err) => {
              console.log(err);
              reject(false);
            });
        });
      }

      processGifting(event, handler) {
        //alert("PROCESSING");
        this.setSelectedGiftItems();
        this.setSelectedGiftItemsQuantity();
        this.removeAllGiftsFromCart().then(() => {
          let data = this.assembleGiftItemData();
          if (data.items.length > 0) {
            this.addGiftsToCart(data).then(() => {
              this.checkGiftsInCart().then((cartGiftsOk) => {
                //alert(cartGiftsOk);
                if (cartGiftsOk) {
                  //alert("OK");
                  goToCheckout();
                  //if(handler) {
                  //    handler.call(this, event);
                  //}
                } else {
                  //alert("NOT OK");
                  this.processGifting();
                }
              });
            });
          } else {
            goToCheckout();
          }
        });
      }

      checkGiftsInCart() {
        //alert("CHECKING GIFTS");
        return new Promise((resolve, reject) => {
          fetch("/cart.js")
            .then((response) => {
              return response.json();
            })
            .then((cart) => {
              let allQuantitiesOk = this.checkGiftQuantities(cart.items);
              let allGiftsDeserved = this.checkIfGiftsDeserved(cart.items);
              //alert(`QUANT OK: ${allQuantitiesOk}, GIFTS DESERVED: ${allGiftsDeserved}`);
              resolve(allQuantitiesOk && allGiftsDeserved);
            })
            .catch((err) => {
              //alert(`ISPADE - ${err}`);
              console.error(err);
            });
        });
      }

      checkGiftQuantities(cartItems) {
        //alert("CHECKING QUANT");
        let allQuantitiesOk = true;
        Object.keys(this.selectedGiftItemsQuantity).forEach((key) => {
          let giftItem = cartItems.filter(
            (item) =>
              item.variant_id == key.split("_")[0] &&
              item.properties["Gift"] == key.split("_")[1]
          )[0];
          if (
            !giftItem ||
            giftItem.quantity != this.selectedGiftItemsQuantity[key]
          ) {
            allQuantitiesOk = false;
          }
        });
        return allQuantitiesOk;
      }

      checkIfGiftsDeserved(cartItems) {
        //alert(`CHECKING GIFTS - ${this.collectionHandles}`);
        let allGiftsDeserved = true;
        let giftItems = cartItems.filter((item) =>
          this.collectionHandles.includes(item.properties["Gift"])
        );
        giftItems.forEach((item) => {
          if (
            !this.selectedGiftItemsQuantity[
              `${item.variant_id}_${item.properties["Gift"]}`
            ]
          ) {
            allGiftsDeserved = false;
          }
        });
        return allGiftsDeserved;
      }
    }
  );
}
